import { useEffect, useState } from 'react'
import ModalComponent from 'components/common/ModalComponent'
import { showAlert } from 'services/alerts.service'
import { makeRequest } from 'services/request.service'

const AgroDataEditModal = ({ isOpen, handleSave, handleClose, selectedAgroData, isBulk, bulkCount, farmId }) => {
  const [activities, setActivities] = useState([])
  const [workers, setWorkers] = useState([])

  useEffect(() => {
    if (!isOpen || !farmId) return
    const token = localStorage.getItem('secret')
    const headers = { Authorization: `Bearer ${token}` }

    makeRequest({ method: 'GET', url: `/management/activities/${farmId}`, headers })
      .then(r => setActivities(r.data ?? []))
      .catch(err => console.error('Failed to load activities', err))

    makeRequest({ method: 'GET', url: `/management/workers-management/${farmId}/all`, headers })
      .then(r => setWorkers(r.data ?? []))
      .catch(err => console.error('Failed to load workers', err))
  }, [isOpen, farmId])

  const getInitialData = () => {
    if (isBulk) return { activityId: '', workerId: '', completionPercentage: '' }
    return {
      activityId: selectedAgroData?.activityId ?? '',
      workerId: selectedAgroData?.workerId ?? '',
      completionPercentage: selectedAgroData?.completionPercentage ?? ''
    }
  }

  const handleSaveClick = (formData) => {
    if (!formData) {
      showAlert({ text: 'Form data is missing', icon: 'error' })
      return
    }

    const payload = {}
    if (formData.activityId !== '' && formData.activityId != null) payload.activityId = Number(formData.activityId)
    if (formData.workerId !== '' && formData.workerId != null) payload.workerId = Number(formData.workerId)
    if (formData.completionPercentage !== '' && formData.completionPercentage != null) {
      const pct = parseFloat(formData.completionPercentage)
      if (pct < 0 || pct > 100) {
        showAlert({ text: 'Completion percentage must be between 0 and 100', icon: 'warning' })
        return
      }
      payload.completionPercentage = pct
    }

    if (Object.keys(payload).length === 0) {
      showAlert({ text: 'No changes to save', icon: 'info' })
      return
    }

    handleSave(payload)
  }

  const title = isBulk
    ? `Edit ${bulkCount} record${bulkCount !== 1 ? 's' : ''}`
    : 'Edit Agro Data'

  return (
    <ModalComponent
      title={title}
      isOpen={isOpen}
      onClose={handleClose}
      onSave={handleSaveClick}
      initialData={getInitialData()}
      key={isOpen ? 'open' : 'closed'}
    >
      {({ formData, handleChange }) => (
        <form className='space-y-4 w-72' autoComplete='off'>
          {isBulk && (
            <p className='text-sm text-gray-500'>Only filled fields will be updated across all selected records.</p>
          )}

          <label className='block text-sm font-medium'>
            Activity
            <select
              name='activityId'
              value={formData?.activityId ?? ''}
              onChange={handleChange}
              className='w-full mt-1 p-2 border rounded'
            >
              <option value=''>— Keep current —</option>
              {activities.map(a => (
                <option key={a.activityId} value={a.activityId}>{a.activityName}</option>
              ))}
            </select>
          </label>

          <label className='block text-sm font-medium'>
            Worker
            <select
              name='workerId'
              value={formData?.workerId ?? ''}
              onChange={handleChange}
              className='w-full mt-1 p-2 border rounded'
            >
              <option value=''>— Keep current —</option>
              {workers.map(w => (
                <option key={w.workerId} value={w.workerId}>
                  {w.firstName} {w.lastName}
                </option>
              ))}
            </select>
          </label>

          <label className='block text-sm font-medium'>
            Completion % (0–100)
            <input
              type='number'
              name='completionPercentage'
              min={0}
              max={100}
              step={0.01}
              value={formData?.completionPercentage ?? ''}
              onChange={handleChange}
              placeholder='Leave blank to keep current'
              className='w-full mt-1 p-2 border rounded'
            />
          </label>
        </form>
      )}
    </ModalComponent>
  )
}

export default AgroDataEditModal
